export default "/fonts/RV-Harmonia-SemiBold.woff?7b124d89087bc2c7a98b3a92d7e96b1d";